module.exports = __webpack_public_path__ + "arrow-slide-next.png?1ed19dcdf00ca3740af96a587a3f0dd4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-slide-next.png
// module id = 158
// module chunks = 0